import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const client = axios.create({ baseURL: API });

// Attach admin token when present
client.interceptors.request.use((config) => {
  const token = localStorage.getItem("bb_admin_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

// ---------------- Files ----------------
export async function uploadFile(file) {
  const fd = new FormData();
  fd.append("file", file);
  const { data } = await client.post("/upload", fd, {
    headers: { "Content-Type": "multipart/form-data" },
  });
  return data; // { url, name, isImage }
}

export function fileUrl(path) {
  if (!path) return "";
  return path.startsWith("http") ? path : `${BACKEND_URL}${path}`;
}

// ---------------- Auth ----------------
export async function login(username, password) {
  const { data } = await client.post("/auth/login", { username, password });
  return data.token;
}

// ---------------- Masters ----------------
export async function getMasters() {
  const { data } = await client.get("/masters");
  return data;
}

export async function resolveMaster(code) {
  if (!code) return null;
  try {
    const { data } = await client.get(`/masters/resolve/${encodeURIComponent(code)}`);
    return data.found ? { name: data.name, code: data.code } : null;
  } catch {
    return null;
  }
}

export async function createMaster(payload) {
  const { data } = await client.post("/masters", payload);
  return data;
}

export async function updateMaster(id, payload) {
  const { data } = await client.put(`/masters/${id}`, payload);
  return data;
}

export async function deleteMaster(id) {
  await client.delete(`/masters/${id}`);
  return true;
}

// ---------------- Partners ----------------
export async function getPartners() {
  const { data } = await client.get("/partners");
  return data;
}

export async function createPartner(payload) {
  const { data } = await client.post("/partners", payload);
  return data;
}

export async function updatePartner(id, payload) {
  const { data } = await client.put(`/partners/${id}`, payload);
  return data;
}

export async function deletePartner(id) {
  await client.delete(`/partners/${id}`);
  return true;
}

// ---------------- Bank pre-fill ----------------
export async function createBankFill(partnerId) {
  const { data } = await client.post(`/partners/${partnerId}/bank-fill`);
  return data; // { token, bankLink, url }
}

export const bookmarkletCode = `javascript:(function(){var s=document.createElement('script');s.src='${API}/bankfill.js?t='+Date.now();document.body.appendChild(s);})();`;
